import { render, staticRenderFns } from "./UserConfirmResetPassword.vue?vue&type=template&id=83707cf2"
import script from "./UserConfirmResetPassword.vue?vue&type=script&lang=js"
export * from "./UserConfirmResetPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports